import { writable } from 'svelte/store';
import { persisted } from 'svelte-persisted-store';

export const loggedInUser = writable();
export const userHasAlias = writable(false);
export const userHasApprovedGoodBahviour = persisted('userHasApprovedGoodBahviour', false);
